import React, { useEffect, useState } from "react";

import { IgAlert, IgDivider, IgTypography } from "@intelligems/ig-theme";
import Stack from "@mui/material/Stack";
import { AllVisibilityButton } from "@src/features/experienceBuilder/modifications/common/AllVisibilityButton";
import { CopyFromOtherGroupsAccordion } from "@src/features/experienceBuilder/modifications/copyMod/CopyFromOtherGroupsAccordion";
import { ModificationListItemFactory } from "@src/features/experienceBuilder/modifications/ModificationListItemFactory";
import { useSelector } from "@src/store";
import { ExperienceBuilderSelector } from "@src/store/slices/experienceBuilder";
import { getVariationMods } from "@src/store/slices/experienceBuilder/common/selectors/getVariationMods";
import { selectedExperience } from "@src/store/slices/experiences";

let dismissedForExperienceId: string | undefined;

export const ModificationsList = () => {
  const mods = useSelector(getVariationMods);
  const experience = useSelector(selectedExperience);
  const hasTargeting = useSelector(
    ExperienceBuilderSelector.hasCustomTargeting
  );

  const [isDismissed, setIsDismissed] = useState(
    dismissedForExperienceId === experience.id
  );

  // Reset dismissal when switching to a different experience
  useEffect(() => {
    if (dismissedForExperienceId !== experience.id) {
      setIsDismissed(false);
    }
  }, [experience.id]);

  const showTargetingAlert = hasTargeting && !isDismissed;

  return (
    <Stack sx={{ flex: 1, minHeight: 0 }}>
      <Stack sx={{ flex: 1, overflowY: "auto", px: 4 }}>
        <Stack spacing={4} sx={{ py: 4 }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <IgTypography variant="body1" fontWeight={600}>
              Active modifications
            </IgTypography>
            <AllVisibilityButton />
          </Stack>
          <Stack spacing={3}>
            {mods.map((mod) => (
              <ModificationListItemFactory key={mod.id} mod={mod} />
            ))}
          </Stack>
        </Stack>
        <IgDivider />
        <CopyFromOtherGroupsAccordion />
      </Stack>
      {showTargetingAlert && (
        <Stack spacing={2} sx={{ px: 4, py: 2, flexShrink: 0 }}>
          <IgAlert
            alertKey="targeting-not-evaluated"
            severity="info"
            message="Targeting rules aren't applied here. Use Preview to test your modifications with targeting."
            onDismiss={() => {
              dismissedForExperienceId = experience.id;
              setIsDismissed(true);
            }}
          />
        </Stack>
      )}
    </Stack>
  );
};
